import React from 'react'
import { Button, DialogOverlay, DialogOverlayActions, Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useLocation } from '@fs/zion-router'
import { i18n } from '@fs/zion-locale'

export default function ToTreeDesignsOverlay({ overlay, pageNumber }) {
  const [t] = useTranslation()
  const { pathname } = useLocation()

  return (
    <DialogOverlay
      title={t('ToTreeDesignsOverlay.title', 'Leaving for Tree Designs...')}
      subtitle={t('ToTreeDesignsOverlay.subtitle', 'Explore different tree styles and add more family members.')}
      {...overlay}
    >
      <Paragraph size="sm">
        {t(
          'ToTreeDesignsOverlay.description',
          'Get creative, add more people, then save and return to your Family Memory Book to update your design here.'
        )}
      </Paragraph>
      <Separator size="sm" />
      <DialogOverlayActions>
        <Button onClick={overlay.close}>{t('common-ui:cancel.action', 'Cancel')}</Button>
        <Button
          emphasis="high"
          to={`/tree-designs/${i18n.language === 'zh' ? 'chinese' : 'global'}/artistic/ginkgo?from=/memory-books${pathname}&pageNumber=${pageNumber}`}
          external
          linkName="Button:Redirect to Tree Designs:Continue"
        >
          {t('common-ui:continue.action', 'Continue')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
